/**
 * Utility functions for mobile classroom detection
 */

/**
 * Determines if the app should run in mobile classroom mode
 * @param hostname - Current hostname (optional, defaults to window.location.hostname)
 * @param schoolName - School name from student data (optional)
 * @returns boolean indicating if in mobile classroom mode
 */
export const isMobileClassroomMode = (
  hostname?: string,
  schoolName?: string
): boolean => {
  const currentHostname = hostname || (typeof window !== 'undefined' ? window.location.hostname : '');

  // Check hostname (10.0.0.10 - physical mobile classroom)
  const isClassroomHostname = currentHostname === "10.0.0.10";

  // Check school name (LiveOlympiad Test School - virtual mobile classroom)
  const isTestSchool = schoolName === "LiveOlympiad Test School";

  return isClassroomHostname || isTestSchool;
};

/**
 * Constants for mobile classroom detection
 */
export const MOBILE_CLASSROOM_CONSTANTS = {
  HOSTNAME: "10.0.0.10",
  SCHOOL_NAME: "LiveOlympiad Test School"
} as const;